export default __webpack_public_path__ + "static/media/olivia_fuson.8966449a.gif";